var React = require('react');
var objectAssign = require('object-assign');
module.exports = function (props) {
    return React.createElement('svg', objectAssign({}, {
        viewBox: '0 0 68 49',
        version: '1.1'
    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
        id: 'Projects',
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none'
    }, React.createElement('g', {
        id: 'Homepage-Login',
        transform: 'translate(-64.000000, -96.000000)'
    }, React.createElement('g', {
        id: 'M-Logo',
        transform: 'translate(64.000000, 96.000000)'
    }, React.createElement('g', { id: 'Color-Bricks' }, React.createElement('path', {
        d: 'M1,1 L21,1 L21,10 L1,10 L1,1 Z',
        id: 'Fill-1',
        fill: '#DE0B73'
    }), React.createElement('path', {
        d: 'M13,10 L30,10 L30,16 L13,16 L13,10 Z',
        id: 'Fill-2',
        fill: '#FF4A00'
    }), React.createElement('path', {
        d: 'M21,3 L27,3 L27,10 L21,10 L21,3 Z',
        id: 'Fill-3',
        fill: '#FF3C3B'
    }), React.createElement('path', {
        d: 'M0,10 L13,10 L13,18 L0,18 L0,10 Z',
        id: 'Fill-4',
        fill: '#FF8000'
    }), React.createElement('path', {
        d: 'M13,16 L30,16 L30,23 L13,23 L13,16 Z',
        id: 'Fill-5',
        fill: '#DE9A0B'
    }), React.createElement('path', {
        d: 'M30,14 L40,14 L40,21 L30,21 L30,14 Z',
        id: 'Fill-6',
        fill: '#FF3C3B'
    }), React.createElement('path', {
        d: 'M25,23 L30,23 L30,37 L25,37 L25,23 Z',
        id: 'Fill-7',
        fill: '#60DB13'
    }), React.createElement('path', {
        d: 'M1,18 L13,18 L13,31 L1,31 L1,18 Z',
        id: 'Fill-8',
        fill: '#FFC107'
    }), React.createElement('path', {
        d: 'M13,23 L25,23 L25,31 L13,31 L13,23 Z',
        id: 'Fill-9',
        fill: '#09C272'
    }), React.createElement('path', {
        d: 'M7,31 L20,31 L20,36 L7,36 L7,31 Z',
        id: 'Fill-10',
        fill: '#0D9FFB'
    }), React.createElement('path', {
        d: 'M0,31 L7,31 L7,42 L0,42 L0,31 Z',
        id: 'Fill-11',
        fill: '#60DB13'
    }), React.createElement('path', {
        d: 'M1,42 L7,42 L7,49 L1,49 L1,42 Z',
        id: 'Fill-12',
        fill: '#0B56DE'
    }), React.createElement('path', {
        d: 'M7,43 L20,43 L20,49 L7,49 L7,43 Z',
        id: 'Fill-13',
        fill: '#2D11AF'
    }), React.createElement('path', {
        d: 'M7,36 L21,36 L21,43 L7,43 L7,36 Z',
        id: 'Fill-14',
        fill: '#9E41FF'
    }), React.createElement('path', {
        d: 'M30,21 L49,21 L49,31 L30,31 L30,21 Z',
        id: 'Fill-15',
        fill: '#FF8000'
    }), React.createElement('path', {
        d: 'M36,31 L43,31 L43,39 L36,39 L36,31 Z',
        id: 'Fill-16',
        fill: '#09C272'
    }), React.createElement('path', {
        d: 'M30,31 L36,31 L36,46 L30,46 L30,31 Z',
        id: 'Fill-17',
        fill: '#0D9FFB'
    }), React.createElement('path', {
        d: 'M39,6 L45,6 L45,21 L39,21 L39,6 Z',
        id: 'Fill-18',
        fill: '#FFC107'
    }), React.createElement('path', {
        d: 'M45,0 L52,0 L52,12 L45,12 L45,0 Z',
        id: 'Fill-19',
        fill: '#DE2A0B'
    }), React.createElement('path', {
        d: 'M52,1 L68,1 L68,12 L52,12 L52,1 Z',
        id: 'Fill-20',
        fill: '#FF4A00'
    }), React.createElement('path', {
        d: 'M45,12 L66,12 L66,21 L45,21 L45,12 Z',
        id: 'Fill-21',
        fill: '#FF3C3B'
    }), React.createElement('path', {
        d: 'M49,21 L58,21 L58,37 L49,37 L49,21 Z',
        id: 'Fill-22',
        fill: '#09C272'
    }), React.createElement('path', {
        d: 'M58,21 L68,21 L68,33 L58,33 L58,21 Z',
        id: 'Fill-23',
        fill: '#BBF130'
    }), React.createElement('path', {
        d: 'M58,33 L67,33 L67,40 L58,40 L58,33 Z',
        id: 'Fill-24',
        fill: '#0B56DE'
    }), React.createElement('path', {
        d: 'M48,37 L58,37 L58,49 L48,49 L48,37 Z',
        id: 'Fill-25',
        fill: '#2D11AF'
    }), React.createElement('path', {
        d: 'M58,40 L68,40 L68,48 L58,48 L58,40 Z',
        id: 'Fill-26',
        fill: '#9E41FF'
    }), React.createElement('path', {
        d: 'M36,39 L40,39 L40,42 L36,42 L36,39 Z',
        id: 'Fill-27',
        fill: '#0B56DE'
    }))))));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-icon-loader!./app/images/Logo.svg
// module id = 529
// module chunks = 1